/* ==========================================================================
   Dr. Glowed — reel verticali
   Autoplay muto solo quando il video è davvero visibile, stop quando esce.
   Clic: si apre grande con l'audio. Se l'utente ha chiesto meno animazioni,
   restano fermi sulla copertina finché non li apre lui.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* La visibilità si calcola sullo scroll invece che con IntersectionObserver:
     è meno elegante ma funziona ovunque, anche dove l'observer non parte. */
  var watching = [];
  var queued = false;

  function evaluate() {
    queued = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    watching.forEach(function (video) {
      var r = video.getBoundingClientRect();
      if (!r.height) return;
      var vw = window.innerWidth || document.documentElement.clientWidth;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      var acrossPx = Math.min(r.right, vw) - Math.max(r.left, 0);
      var ratio = visible / r.height;
      var across = r.width ? acrossPx / r.width : 0;
      if (ratio > 0.4 && across > 0.55) {
        if (video.preload === 'none') video.preload = 'auto';
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!video.paused) {
        video.pause();
        var shell = video.closest('[data-dg-reel]');
        if (shell && shell.classList.contains('is-loud')) {
          shell.classList.remove('is-loud');
          video.muted = true;
        }
      }
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    // timer e non requestAnimationFrame: in una scheda in secondo piano rAF
    // non parte, e i video resterebbero fermi per sempre
    setTimeout(evaluate, 90);
  }

  function inlinePlayback() {
    if (reduce) return;
    watching = [];
    document.querySelectorAll('[data-dg-reel] video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      watching.push(v);
    });
    watching.forEach(function (v) {
      var shell = v.closest('[data-dg-reel]');
      var fill = shell ? shell.querySelector('.dg-reel__bar i') : null;
      if (!fill || v.dataset.dgBar) return;
      v.dataset.dgBar = '1';
      v.addEventListener('timeupdate', function () {
        if (!v.duration) return;
        fill.style.width = (v.currentTime / v.duration) * 100 + '%';
      });
    });

    if (!watching.length) return;
    window.removeEventListener('scroll', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.querySelectorAll('[data-dg-reels]').forEach(function (track) {
      if (track.dataset.dgTrackBound) return;
      track.dataset.dgTrackBound = '1';
      track.addEventListener('scroll', schedule, { passive: true });
    });
    schedule();
  }

  /* ---------- frecce del carosello ---------- */
  function arrows(scope) {
    scope.querySelectorAll('.dg-reels__wrap').forEach(function (wrap) {
      if (wrap.dataset.dgArrows) return;
      wrap.dataset.dgArrows = '1';
      var track = wrap.querySelector('[data-dg-reels]');
      var prev = wrap.querySelector('[data-dg-reels-prev]');
      var next = wrap.querySelector('[data-dg-reels-next]');
      if (!track || !prev || !next) return;

      function step() {
        var first = track.querySelector('.dg-reel');
        if (!first) return 240;
        return first.getBoundingClientRect().width + 14;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        var need = track.scrollWidth > track.clientWidth + 4;
        prev.style.visibility = need ? '' : 'hidden';
        next.style.visibility = need ? '' : 'hidden';
      }
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () {
        clearTimeout(track._dgT);
        track._dgT = setTimeout(sync, 80);
      }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* ---------- lightbox ---------- */
  var box = null;

  function buildBox() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'dg-reelbox';
    box.innerHTML =
      '<button type="button" class="dg-reelbox__x" aria-label="Close">&times;</button>' +
      '<video controls playsinline preload="auto"></video>';
    document.body.appendChild(box);

    var close = function () {
      var v = box.querySelector('video');
      v.pause();
      v.removeAttribute('src');
      v.load();
      box.classList.remove('is-on');
      document.body.style.overflow = '';
    };

    box.querySelector('.dg-reelbox__x').addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-on')) close();
    });
    return box;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    // l'altoparlante accende l'audio sul posto, come nei reel veri
    var speaker = e.target.closest('[data-dg-reel-sound]');
    if (speaker) {
      e.preventDefault();
      e.stopPropagation();
      var shell = speaker.closest('[data-dg-reel]');
      var vid = shell.querySelector('video');
      var loud = shell.classList.toggle('is-loud');
      // uno solo alla volta
      document.querySelectorAll('[data-dg-reel].is-loud').forEach(function (other) {
        if (other !== shell) {
          other.classList.remove('is-loud');
          var ov = other.querySelector('video');
          if (ov) ov.muted = true;
        }
      });
      vid.muted = !loud;
      if (loud && vid.paused) {
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
      return;
    }

    var reel = e.target.closest('[data-dg-reel]');
    if (!reel) return;
    var src = reel.getAttribute('data-src');
    if (!src) return;

    var b = buildBox();
    var v = b.querySelector('video');
    v.src = src;
    v.currentTime = 0;
    v.muted = false;
    b.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });

  function start() {
    inlinePlayback();
    arrows(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

/* ==========================================================================
   Dr. Glowed — linguette e carte che si girano
   Stanno qui perché sono due comportamenti minuscoli e non vale un file a testa.
   ========================================================================== */
(function () {
  'use strict';

  function tabs(scope) {
    scope.querySelectorAll('[data-dg-tabs]').forEach(function (root) {
      var btns = [].slice.call(root.querySelectorAll('.dg-tabs__btn'));
      var panels = [].slice.call(root.querySelectorAll('.dg-tabs__panel'));
      if (!btns.length) return;

      btns.forEach(function (btn, i) {
        if (btn.dataset.dgBound) return;
        btn.dataset.dgBound = '1';
        btn.addEventListener('click', function () {
          btns.forEach(function (b, j) {
            b.setAttribute('aria-selected', j === i ? 'true' : 'false');
          });
          panels.forEach(function (p, j) {
            p.classList.toggle('is-on', j === i);
          });
        });
      });
    });
  }

  function flips(scope) {
    scope.querySelectorAll('[data-dg-flip]').forEach(function (card) {
      if (card.dataset.dgBound) return;
      card.dataset.dgBound = '1';
      var link = card.querySelector('a[href]');
      card.addEventListener('click', function () {
        // primo tocco gira, secondo apre. Col mouse gira già l'hover: va dritto.
        var fine = window.matchMedia && window.matchMedia('(hover: hover)').matches;
        if (fine || card.classList.contains('is-flipped')) {
          if (link) window.location.href = link.getAttribute('href');
          return;
        }
        card.classList.add('is-flipped');
      });
    });
  }

  function boot() {
    tabs(document);
    flips(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
